import * as variables from '../../variables.js';
import Debouncer from '../../lib/NewDebouncer';
const MarkerClusterer = require('@googlemaps/markerclustererplus');
// NOTE: declare function require is needed to import MarkerClusterer
declare function require(name: string): any;

import * as $ from 'jquery';
import 'slick-carousel';

type MapController = {
	map: google.maps.Map,
	markers: google.maps.Marker[],
	baseCenter: google.maps.LatLng,
	infoWindows: google.maps.InfoWindow[]
};

type MarkerProvider = (
	controller: MapController,
) => google.maps.Marker[];

type ItemType = {
	label?: string,
	color?: string,
	markers: google.maps.Marker[],
	iconGenerator: (legendItem: ItemType) => string,
	excludeFromLegend?: boolean
};

const circleGenerator = (legendItem: ItemType) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" width="45" height="45"><circle fill="${encodeURIComponent(legendItem.color)}" stroke="${encodeURIComponent('#FFF')}" stroke-width="3" cx="22.5" cy="22.5" r="9"> </circle></svg>`;
const rectGenerator = (legendItem: ItemType) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20"><rect fill="${encodeURIComponent(legendItem.color)}" stroke="${encodeURIComponent('#FFF')}" stroke-width="6" width="20" height="20"> </rect></svg>`;

const clusterByType: boolean = false;
const allMarkers: google.maps.Marker[] = [];
const itemTypes: { [index: string]: ItemType } = {
	COMPLETE: {
		label: 'Complete Sale',
		color: variables.color_COMPLETE as string,
		markers: [],
		iconGenerator: circleGenerator
	},
	DISTRESSED: {
		label: 'Distressed Sale',
		color: variables.color_DISTRESSED as string,
		markers: [],
		iconGenerator: circleGenerator
	},
	PARTIAL: {
		label: 'Partial Sale',
		color: variables.color_PARTIAL as string,
		markers: [],
		iconGenerator: circleGenerator
	},
	SELL_AND_CONSULT: {
		label: 'Sell & Consult',
		color: variables.color_SELL_AND_CONSULT as string,
		markers: [],
		iconGenerator: circleGenerator
	},
	MOVE_AND_ACQUIRE: {
		label: 'Move to Acquire™',
		color: variables.color_MOVE_AND_ACQUIRE as string,
		markers: [],
		iconGenerator: circleGenerator
	},
	MERGE_IN: {
		label: 'Merge In™',
		color: variables.color_MERGE_IN as string,
		markers: [],
		iconGenerator: circleGenerator
	},
	POCKET: {
		label: 'Off Market',
		markers: [],
		iconGenerator: rectGenerator,
	},
	DEFAULT: {
		label: '',
		color: variables.color_DEFAULT as string,
		markers: [],
		iconGenerator: circleGenerator,
		excludeFromLegend: true
	},
	FAVORITE: {
		label: 'Bookmarked',
		markers: [],
		iconGenerator: legendItem => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" width="45" height="45"><path fill="${encodeURIComponent(legendItem.color)}" stroke="${encodeURIComponent('#FFF')}" stroke-width="1.5" d="M20.4 10.8c.4-.4.4-1.1 0-1.5-.1-.1-.3-.2-.5-.3l-4.8-.7-2-4.4c-.2-.5-.8-.8-1.4-.6-.3.1-.5.3-.6.6L9 8.3l-4.9.8c-.6.1-.9.7-.8 1.2 0 .2.1.4.3.5l3.5 3.6v.1l-.8 4.9c-.1.6.3 1.2.9 1.3.2 0 .5 0 .7-.1l4.1-2.3 4.1 2.3c.6.3 1.2 0 1.5-.5.1-.2.1-.5.1-.7l-.8-4.9v-.1l3.5-3.6z"> </path></svg>`,
		excludeFromLegend: true
	}
};
/* NOTE: Actual bounds
const CONUS_BOUNDS = {
	north: 48.995489,
	south: 25.1659058,
	west: -123.3701602,
	east: -69.1583181,
};
*/
const CONUS_BOUNDS = {
	north: 49.384358,
	south: 24.396308,
	west: -124.848974,
	east: -66.885444,
};
const CONUS_CENTER = {
	lat: 37.8074615,
	lng: -96
};
let mapStyles: google.maps.MapTypeStyle[] = [
	{
		"elementType": "geometry",
		"stylers": [{ "color": "#f5f5f5" }]
	},
	{
		"elementType": "labels.icon",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#616161" }]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [{ "color": "#f5f5f5" }]
	},
	{
		"featureType": "administrative",
		"elementType": "geometry",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.stroke",
		"stylers": [{ "color": "#b6b6b6" },
		{ "visibility": "on" },
		{ "weight": 1.5 }]
	},
	{
		"featureType": "administrative.country",
		"elementType": "labels.text",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.land_parcel",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#bdbdbd" }]
	},
	{
		"featureType": "administrative.neighborhood",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.province",
		"elementType": "geometry.stroke",
		"stylers": [{ "color": "#b6b6b6" },
		{ "visibility": "on" },
		{ "weight": 2.5 }]
	},
	{
		"featureType": "poi",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{ "color": "#eeeeee" }]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#757575" }]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{ "color": "#e5e5e5" }]
	},
	{
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#9e9e9e" }]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{ "color": "#ffffff" }]
	},
	{
		"featureType": "road",
		"elementType": "labels",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.arterial",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#757575" }]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{ "color": "#dadada" }]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#616161" }]
	},
	{
		"featureType": "road.local",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#9e9e9e" }]
	},
	{
		"featureType": "transit",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{ "color": "#e5e5e5" }]
	},
	{
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{ "color": "#eeeeee" }]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{ "color": "#c9c9c9" }]
	},
	{
		"featureType": "water",
		"elementType": "labels.text",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#9e9e9e" }]
	}
];

let mapMarkerClustererRef: MarkerClusterer = null;

let mapElement = document.getElementById('map');
let mapInfoWindows: InfoWindowManager = null;

const createLegend = function () {
	const UL = document.createElement('UL');
	UL.classList.add('mapLegend');
	for (let key in itemTypes) {
		const itemType = itemTypes[key];
		if (itemType.excludeFromLegend) continue;
		let LI = document.createElement('LI');
		LI.classList.add(key);
		LI.innerHTML = itemType.label;

		if (itemType.label === 'Off Market') {
			LI.innerHTML = '<span aria-label="Off Market Listing available exclusively to NextLevel™ buyers">' + itemType.label + '</span>';
		}

		UL.appendChild(LI);
	}
	mapElement.parentElement.insertBefore(UL, mapElement.nextSibling);
}

declare global {
	interface Window {
		infoWindowTimeout?: number;
	}
}

const distanceToEdges = (map: google.maps.Map, marker: google.maps.MVCObject): { [index: string]: number } => {
	// left, right, top, bottom
	const projection = map.getProjection();
	const mPoint = projection.fromLatLngToPoint(marker.get('position'));
	const bounds = map.getBounds();
	const pixelSize = Math.pow(2, -map.getZoom());

	const northEast = bounds.getNorthEast();
	const southWest = bounds.getSouthWest();

	const mPos = marker.get('position');
	const leftPoint = projection.fromLatLngToPoint(new google.maps.LatLng({ lat: mPos.lat(), lng: southWest.lng() }));
	const rightPoint = projection.fromLatLngToPoint(new google.maps.LatLng({ lat: mPos.lat(), lng: northEast.lng() }));

	const topPoint = projection.fromLatLngToPoint(new google.maps.LatLng({ lat: northEast.lat(), lng: mPos.lng() }));
	const bottomPoint = projection.fromLatLngToPoint(new google.maps.LatLng({ lat: southWest.lat(), lng: mPos.lng() }));

	return {
		L: -(leftPoint.x - mPoint.x) / pixelSize,
		R: (rightPoint.x - mPoint.x) / pixelSize,
		T: -(topPoint.y - mPoint.y) / pixelSize,
		B: (bottomPoint.y - mPoint.y) / pixelSize
	};
}

class InfoWindowManager {
	private controller: MapController;
	private defaultWidth: number = 400;
	private defaultHeight: number = 150;
	// magic number: blame google
	private arrowOffset: number = 11;

	public close(ignoreCanBeRemoved = true) {
		let min = 0;
		const infoWindows = this.controller.infoWindows;
		while (infoWindows.length > min) {
			if (ignoreCanBeRemoved || (infoWindows[infoWindows.length - 1] as any).canBeRemoved) {
				infoWindows.pop().close();
			} else {
				min++;
				(infoWindows[infoWindows.length - 1] as any).canBeRemoved = true;
			}
		}
		return this;
	}
	public delayClose() {
		window.infoWindowTimeout = window.setTimeout(() => this.close(), 2000);
	};
	public cancelClose() {
		window.clearTimeout(window.infoWindowTimeout);
		return this;
	};
	public getContent(elements: HTMLElement[]) {
		let ret = '';
		elements.forEach(e => {
			ret += e.outerHTML;
		});
		return `<div class="mapToolTipWrap">${ret}</div>`.replace(/mapListingItem/gi, 'mapToolTip');
	};
	public getBoundsCollisions(marker: google.maps.MVCObject): { [index: string]: any } {
		const edges = distanceToEdges(this.controller.map, marker);
		// TODO: create getWidthHeight function;
		const sizes = marker.get('styles')?.[0] ?? {width: 45, height: 45};
		// to make code less verbose
		const H = this.arrowOffset + sizes.height / 2;
		const W = this.arrowOffset + sizes.width / 2;
		const scrollbar = 20;

		// console.log( {
		// 	T: (edges.T - H - this.defaultHeight),
		// 	B: (edges.B - H - this.defaultHeight),
		// 	R: (edges.R - W - this.defaultWidth - scrollbar),
		// 	L: (edges.L - W - this.defaultWidth),
		// 	T2: (edges.T - H - (this.defaultHeight / 2)),
		// 	B2: (edges.B - H - (this.defaultHeight / 2)),
		// 	L2: (edges.L - H - (this.defaultWidth / 2)),
		// 	R2: (edges.R - H - (this.defaultWidth / 2))
		// });
		return {
			T: (edges.T - H - this.defaultHeight < 0),
			B: (edges.B - H - this.defaultHeight < 0),
			R: (edges.R - W - this.defaultWidth - scrollbar < 0),
			L: (edges.L - W - this.defaultWidth < 0),
			T2: (edges.T - H - (this.defaultHeight / 2) < 0),
			B2: (edges.B - H - (this.defaultHeight / 2) < 0),
			R2: (edges.R - H - (this.defaultWidth / 2) < 0),
			L2: (edges.L - H - (this.defaultWidth / 2) < 0)
		};
	};
	public getPixelOffset(marker: google.maps.MVCObject): google.maps.Size {
		let collisions = this.getBoundsCollisions(marker);
		let offsetX = 0;
		let offsetY = 0;
		const sizes = marker.get('styles')?.[0] ?? {width: 0, height: 0};
		// Reduces verbosity
		let W = this.defaultWidth + sizes.width;
		let H = this.defaultHeight + sizes.height;
		let gap = this.arrowOffset;

		// Calculations are based off the default positioning which is top center
		if (!collisions.L || !collisions.R) {
			offsetX = (W / 2 + gap) * (collisions.L ? 1 : -1);
			offsetY = (H / 2 + gap);

			if (collisions.T2 || collisions.B2) {
				offsetX = offsetX + (gap * (collisions.L ? -1 : 1));
				offsetY = gap + (collisions.T2 ? H : 0);
			}
			// console.log(!collisions.L ? 'L' : 'R', (collisions.T2 || collisions.B2) ? !collisions.T2 ? 'T' : 'B' : '');
		} else {
			if (!collisions.B) {
				offsetY = H + gap;
			}
			if (collisions.L2 || collisions.R2) {
				offsetX = (W / 4 + gap) * (collisions.L2 ? 1 : -1);
			}
			// console.log(!collisions.B ? 'B' : 'T', (collisions.L2 || collisions.R2) ? !collisions.L2 ? 'L' : 'R' : '');
		}

		return new google.maps.Size(offsetX, offsetY);
	};
	public createCarousel() {
		let $elem = $('.mapToolTipWrap');
		//@ts-ignore
		$elem.slick({
			autoplay: false,
			nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
			prevArrow: '<button type="button" class="slick-prev"><span>Prev</span></button>',
			mobileFirst: false,
			variableWidth: false,
			swipeToSlide: true,
			infinite: false,
			dots: true,
			appendDots: $elem.append('DIV.test')
		});
	}
	public handleClick(marker: google.maps.MVCObject, elements: HTMLElement[]) {
		this.cancelClose();
		this.close();

		const infoWindow = new google.maps.InfoWindow({
			content: this.getContent(elements),
			disableAutoPan: true,
			zIndex: 202,
			pixelOffset: this.getPixelOffset(marker)
		});

		infoWindow.open(this.controller.map, marker);
		(infoWindow as any).canBeRemoved = false;
		this.controller.infoWindows.push(infoWindow);
		infoWindow.addListener('domready', () => {
			this.createCarousel();
			document.dispatchEvent(new CustomEvent('registerBookmarkableArea', {bubbles: false, detail: document.querySelector('.mapToolTipWrap')}));
		});
		infoWindow.addListener('closeclick', () => {
			this.close();
		});
	};

	constructor(controller: MapController) {
		this.controller = controller;
	}
}

const createMarkerClusterer = (map: google.maps.Map, markers: google.maps.Marker[], type = "") => {
	let mapMarkerClusterer = new MarkerClusterer(map, markers, {
		gridSize: 44,
		styles: [{
			height: 44,
			width: 44,
			textColor: '#000',
			textSize: 20,
			anchorIcon: [0, 22],
			textLineHeight: 44,
			fontWeight: '700'
		}],
		averageCenter: true,
		minimumClusterSize: 2,
		zoomOnClick: false,
		clusterClass: `mapCluster mapCluster--${type}`
	});
	mapMarkerClustererRef = mapMarkerClusterer;

	google.maps.event.addListener(mapMarkerClusterer, "click", (mc) => {
		let markers = mc.getMarkers();

		/* -----------
			NOTE: whooooooah nelly! this was tough to figure out
			Convert lat/long from cluster object to a usable MVCObject
		----------- */
		const target = new google.maps.MVCObject;
		target.set('position', mc.clusterIcon_.center_);
		target.set('styles', mc.clusterIcon_.styles_)

		let elements = [];
		for (let i = 0, l = markers.length; i < l; i++) {
			elements.push(markers[i].get('sourceElement'));
		}

		mapInfoWindows.handleClick(target, elements as HTMLElement[]);
	});
}

const calculateIconURL = (itemType: string[] = ['DEFAULT']) => {
	let legendItem = itemTypes['DEFAULT'];
	for (let it of itemType) { // This progressively collapses the itemTypes giving priority to the later types
		legendItem = {...legendItem, ...itemTypes[it]};
	}
	return `data:image/svg+xml;utf8,${legendItem.iconGenerator(legendItem)}`;
};

const addMarker = (
	newMarkers: google.maps.Marker[],
	lat: any,
	lon: any,
	itemType: string[] = ['DEFAULT'],
	element: HTMLElement,
) => {
	const marker = new google.maps.Marker({
		position: new google.maps.LatLng(Number(lat), Number(lon))
		,icon: {
			url: calculateIconURL(itemType)
		}
	});
	marker.addListener('click', (event: any) => {
		mapInfoWindows.handleClick(marker, [element]);
		event.stop();
	});
	newMarkers.push(marker);
	return marker;
};

let markerProvider: MarkerProvider = (controller) => {
	const results = document.querySelectorAll('.mapListingItem') as NodeListOf<HTMLElement>;
	let newMarkers: google.maps.Marker[] = [];

	// add markers based on results
	for (let i = 0; i < results.length; i++) {
		const result = results.item(i);
		const dataAcquisitionType = result.getAttribute("data-acquisition-type") ?? "DEFAULT";
		if ( !dataAcquisitionType || !result.getAttribute('data-lat') || !result.getAttribute('data-lon')){
			continue;
		}
		let lat  = result.getAttribute('data-lat');
		let lon  = result.getAttribute('data-lon');
		let type = dataAcquisitionType.split(',');

		// "hack" to place Hawaii locations off coast of California
		if (result.getAttribute('data-controller') === 'HI') {
			lat = "32.143060";
			lon = "-122.505549";
		}

		let marker = addMarker(newMarkers, lat, lon, type ?? ['DEFAULT'], result);
		marker.set('sourceElement', result);
		marker.set('practiceId', result.getAttribute('data-practice-id'));

		itemTypes[!type ? 'DEFAULT' : type[type.length - 1]].markers.push(marker);
		allMarkers.push(marker);
	}

	if (clusterByType){
		for (let type in itemTypes) {
			createMarkerClusterer(controller.map, itemTypes[type].markers, type);
		}
	} else {
		// console.log(allMarkers);
		createMarkerClusterer(controller.map, allMarkers);
	}

	return newMarkers;
}

const controlBounds = (map: google.maps.Map) => {
	let fixBounds = () => {
		mapInfoWindows.close();
		map.fitBounds(CONUS_BOUNDS);
		mapElement.setAttribute('data-zoom', map.getZoom().toString());
	};

	const handleBounds = new Debouncer(fixBounds, false, 500);
	window.addEventListener('resize', handleBounds.run);

	fixBounds();

	/*DEBUG code to see the bounds */
	// const rectangle = new google.maps.Rectangle({
	// 	strokeColor: "#FF0000",
	// 	strokeOpacity: 0.8,
	// 	strokeWeight: 2,
	// 	fillColor: "#FF0000",
	// 	fillOpacity: 0.35,
	// 	map,
	// 	bounds: CONUS_BOUNDS,
	// });
}

const MapInitializer = () => {
	const controller: MapController = {
		map: null,
		markers: null,
		baseCenter: null,
		infoWindows: []
	};

	// googlemaps callback
	(window as any).initMap = () => {
		if (!mapElement) {
			return;
		}

		if (controller.map === null) {
			controller.map = new google.maps.Map(mapElement, {
				center: CONUS_CENTER,
				fullscreenControl: false,
				gestureHandling: "none",
				mapTypeControl: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				restriction: {
					latLngBounds: CONUS_BOUNDS,
					strictBounds: false,
				},
				streetViewControl: false,
				styles: mapStyles,
				zoom: 6,
				minZoom: 3,
				maxZoom: 6,
				zoomControl: false
			});
		}

		// Markers
		controller.markers = markerProvider(controller);
		if (controller.markers.length > 0) {
			controller.markers.forEach(marker => marker.setMap(controller.map));
		}

		createLegend();
		controlBounds(controller.map);
	};

	mapInfoWindows = new InfoWindowManager(controller);

	document.addEventListener('click', function (event) {
		let parent: HTMLElement = event.target as HTMLElement;
		do {
			if (parent.style.zIndex === '202') {
				event.stopPropagation();
				return;
			}
		} while ((parent = parent.parentElement) !== null && (parent.id === null || parent.id === ''));

		mapInfoWindows.close(false);
	});
	document.addEventListener('keyup', function (event) {
		if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
			mapInfoWindows.close(false);
		}
	});

	document.addEventListener("bookmarkStateChange", evt => {
		const practiceId = (evt as any).practiceId as string;
		controller.markers.filter(marker => marker.get("practiceId") === practiceId).forEach(marker => {
			const sourceElement = marker.get("sourceElement") as HTMLElement;
			let acquisitionType = sourceElement.getAttribute('data-acquisition-type');
			if (acquisitionType.indexOf(",FAVORITE") !== -1) {
				acquisitionType = acquisitionType.replace(/,FAVORITE/, "");
			} else {
				acquisitionType = acquisitionType + ",FAVORITE";
			}
			sourceElement.setAttribute('data-acquisition-type', acquisitionType);
			marker.setIcon({
				url: calculateIconURL(acquisitionType.split(','))
			});
		});
	})
};

export default MapInitializer;
